<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('gestiune.bonFiscal')"></general-top-bar> -->

    <div class="action-buttons">
      <div class="left-buttons" style="display: flex; align-items: center; gap: 20px; margin-top: 15px;">
        <div class="form-group">
          <label>{{ $t('gestiune.locatie') }}</label>
          <select class="form-control" v-model="selectedLocation" :disabled="loading">
            <option :value="null">Selectează</option>
            <optgroup
              v-for="group in groupedLocations"
              :key="group.vat"
              :label="`VAT: ${group.vat}`"
            >
              <option
                v-for="loc in group.locations"
                :key="loc.id"
                :value="loc"
              >
                {{ loc.name }}
              </option>
            </optgroup>
          </select>
        </div>

        <div class="form-group" style="flex: 2;">
          <label>Tip vânzare</label>
          <select class="form-control" v-model="selectedTipVanzare" :disabled="loading">
            <option :value="null">Selectează</option>
            <option
              v-for="(method, index) in paymentMethods"
              :key="index"
              :value="method.value"
            >
              {{ method.label }}
            </option>
          </select>
        </div>

        <div class="form-group" style="flex: 1 1 3%;">
          <label>Date și oră</label>
          <el-date-picker
            type="datetimerange"
            v-model="searchDate"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="w-100"
            :picker-options="pickerOptions"
            :name="['date_from', 'date_to']"
            :disabled="loading"
          ></el-date-picker>
        </div>

        <div class="search-button-reports">
          <button
              :title="$t('reports.search')"
              class="btn add mar-rt-10"
              @click="onSearch"
          >
              <i class="ti-search"></i>
              <span>{{ $t('general.search') }}</span>
          </button>
        </div>
      </div>

      <div class="right-buttons">
      </div>
    </div>
    <!--End General Top Bar -->

    <div class="card mar-to-15 tableInvoice">
      <div class="card-content">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="data-table">
          <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="width: 100%;">
            <!-- Număr bon -->
            <el-table-column :label="$t('gestiune.nr')" prop="nr" width="100"
                 :formatter="(row) => row.nr ? row.nr : 'N/A'">
            </el-table-column>

            <!-- Data -->
            <el-table-column
              prop="date"
              :label="$t('gestiune.date')"
              :formatter="formatDate"
            ></el-table-column>

            <!-- Număr de produse -->
            <el-table-column
              :label="$t('gestiune.nrProduse')"
              :formatter="(row) => (row.products && row.products.length) ? row.products.length : 0"
            ></el-table-column>

            <!-- Fiscalizat -->
            <el-table-column
              :label="$t('gestiune.fiscalizat')"
              :formatter="(row) => row.is_fiscal ? 'Da' : 'Nu'"
            ></el-table-column>

            <el-table-column
              label="Nr. Bon Fiscal"
              :formatter="(row) => (row.rawDataParsed && row.rawDataParsed.ReceiptNumber) ? row.rawDataParsed.ReceiptNumber : '—'"
            ></el-table-column>

            <el-table-column
              label="Nr. Z Bon Fiscal"
              :formatter="(row) => (row.rawDataParsed && row.rawDataParsed.ReceiptInfo) ? row.rawDataParsed.ReceiptInfo : '—'"
            ></el-table-column>

            <!-- Tip vânzare / metodă de plată -->
            <el-table-column
              prop="tip_vanzare"
              :label="$t('gestiune.tipVanzare')"
              :formatter="formatTipVanzare"
            ></el-table-column>

            <el-table-column label="Sursă">
              <template slot-scope="scope">
                <span>{{ scope.row.source || '—' }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Order ID">
              <template slot-scope="scope">
                <span
                  @click.stop="goToOrder(scope.row)"
                  class="order-id-label"
                >
                  {{ scope.row.externalOrderId || 'N/A' }}
                </span>
              </template>
          </el-table-column>
          <el-table-column :label="$t('general.actions')" width="100">
            <template slot-scope="scope">
              <el-dropdown trigger="click" placement="bottom-end">
                <!-- Trigger: sageata jos într-un chenar -->
                <span class="arrow-box">
                  &#9662; <!-- sageata jos -->
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                  <el-dropdown-item
                    @click.native="goToBonFiscal(scope.row)"
                  >
                    {{$t('general.see')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          </el-table>
          <el-pagination
            layout="prev, pager, next"
            :total="totalItems"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handlePageChange"
            style="margin-top: 15px; text-align: right;"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      companyID: null,
      vatNumber: null,
      selectedLocation: null,
      searchDate: null,
      selectedTipVanzare: null,
      pickerOptions: {
        shortcuts: [
          {
            text: 'Astăzi',
            onClick (picker) {
              const start = new Date()
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ieri',
            onClick (picker) {
              const start = new Date()
              start.setDate(start.getDate() - 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setDate(end.getDate() - 1)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 7 zile',
            onClick (picker) {
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              const start = new Date()
              start.setDate(end.getDate() - 6)
              start.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 30 de zile',
            onClick (picker) {
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              const start = new Date()
              start.setDate(end.getDate() - 29)
              start.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna curentă',
            onClick (picker) {
              const start = new Date()
              start.setDate(1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna trecută',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date(date.getFullYear(), date.getMonth(), 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul curent',
            onClick (picker) {
              const start = new Date(new Date().getFullYear(), 0, 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul trecut',
            onClick (picker) {
              const year = new Date().getFullYear() - 1
              const start = new Date(year, 0, 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date(year, 11, 31)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick ({ maxDate, minDate }) {
          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0)
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999)
          }
        }
      }
    }
  },
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    paymentMethods () {
      return [
        { value: 'CASH', label: 'CASH' },
        { value: 'CARD_POS', label: 'CARD POS' },
        { value: 'bon_fiscal', label: 'BON FISCAL' },
        { value: 'PROTOCOL', label: 'PROTOCOL' },
        { value: 'VIRAMENT', label: 'VIRAMENT' },
        { value: 'MANACARE_PERSONAL', label: 'STAFF FOOD' },
        { value: 'ROOM', label: 'ROOM' },
        { value: 'EVENT', label: 'EVENT' },
        { value: 'FOLIO', label: 'FOLIO' },
        { value: 'SPLIT', label: 'SPLIT' },
        { value: 'ONLINE', label: 'ONLINE' },
        { value: 'GLOVO_CARD', label: 'GLOVO CARD' },
        { value: 'GLOVO_CASH', label: 'GLOVO CASH' },
        { value: 'WOLT_CARD', label: 'WOLT CARD' },
        { value: 'BOLT_CARD', label: 'BOLT CARD' }
      ]
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  methods: {
    onSearch () {
      this.currentPage = 1

      this.fetchBonsFiscale(
        this.selectedLocation,
        this.currentPage,
        this.pageSize
      )
    },
    goToOrder (row) {
      if (row && row.externalOrderId) {
        this.$router.push('/orders/view/' + row.externalOrderId)
      }
    },
    goToBonFiscal (row) {
      if (row && row._id) {
        this.$router.push({
          name: 'ManagementBonFiscalView',
          params: { id: row._id }
        })
      }
    },
    handlePageChange (page) {
      this.currentPage = page
      this.fetchBonsFiscale(this.selectedLocation, this.currentPage, this.pageSize)
    },
    formatDate (row, column, cellValue) {
      if (!cellValue) return ''

      const date = new Date(cellValue)

      return date.toLocaleString('ro-RO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    async fetchBonsFiscale (location = null, page = 1, pageSize = 25) {
      if (
        !location ||
        (Array.isArray(location) && location.length === 0)
      ) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        })

        this.tableData = []
        this.totalItems = 0

        return
      }

      if (!this.searchDate || this.searchDate.length !== 2) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați un interval de dată și oră pentru căutare',
          confirmButtonText: 'OK'
        })

        this.tableData = []
        this.totalItems = 0

        return
      }

      try {
        let startDate, endDate

        if (this.searchDate && this.searchDate.length === 2) {
          startDate = new Date(this.searchDate[0]).toISOString()
          endDate = new Date(this.searchDate[1]).toISOString()
        } else {
          // fallback → ziua curentă
          const today = new Date()
          const isoDate = today.toISOString().split('T')[0]
          startDate = isoDate + 'T00:00:00Z'
          endDate = isoDate + 'T23:59:59Z'
        }

        const params = new URLSearchParams({
          externalCompanyId: this.companyID,
          startDate,
          endDate
        })

        if (location) {
          if (Array.isArray(location)) {
            const ids = location.map(l => l.true_id).filter(Boolean)
            ids.forEach(id => params.append('externalLocationId', id)) // trimite ca array
          } else if (location.id && location.true_id) {
            params.append('externalLocationId', location.true_id)
          }
        } else {
          const allLocations = this.groupedLocations.flatMap(group => group.locations)
          const ids = allLocations.map(l => l.true_id).filter(Boolean)
          for (const id of ids) {
            params.append('externalLocationId', encodeURIComponent(id))
          }
        }

        params.append('page', page)
        params.append('limit', pageSize)

        if (this.selectedTipVanzare) {
          params.append('tip_vanzare', this.selectedTipVanzare)
        }
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = setTimeout(() => {
          this.loading = true
        }, 100)
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/bons_fiscale?${params.toString()}`, {
          method: 'GET'
        })
        const result = await response.json()
        clearTimeout(this.loadingTimeout)
        this.loading = false
        this.totalItems = result.total || 0
        this.currentPage = result.currentPage || page
        this.pageSize = result.pageSize || pageSize

        this.tableData = Array.isArray(result.bons_fiscale)
        ? result.bons_fiscale.map(bon => {
          try {
            if (bon.raw_data && typeof bon.raw_data === 'string') {
              bon.rawDataParsed = JSON.parse(bon.raw_data)
            }
          } catch (e) {
            console.warn('❗ Eroare la decodare/parsing raw_data:', e)
            bon.rawDataParsed = {}
          }

          bon.source = bon.source
          return bon
        })
        : []
      } catch (error) {
        console.error('❌ Eroare la fetch bons fiscale:', error)
      }
    },
    formatTipVanzare (row, column, cellValue) {
      if (!cellValue) return ''

      // înlocuiește underscore cu spațiu și capitalizează
      return cellValue
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.el-pagination {
  text-align: center !important;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.left-buttons button {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.right-button {
  margin-left: auto;
}

.button-group {
  display: flex;
  justify-content: flex-end;
}
.el-dropdown-menu {
  min-width: 140px;
  font-size: 14px;
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px; /* spațiu în jurul săgeții */
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoare săgeată */
}

.arrow-box:hover {
  background-color: #674BD2 !important; /* background violet la hover */
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata devine albă */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 150px;
  font-size: 14px;
}
.el-dropdown-item {
  padding: 6px 12px;
}
.button-group .btn {
  margin-right: 10px;
}
.order-id-label {
  background-color: #4CAF50 !important; /* verde intens */
  color: white;
  padding: 3px 8px;
  border-radius: 50px;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
  user-select: none;
}
.button-group .btn:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Outputs/ManagementBonFiscal.vue